import styled from "styled-components/macro";
import PropTypes from "prop-types";
import { useIsSignupClosed } from "Signups/SharedComponents/useIsSignupClosed";
import { useSignupListHasRespondents } from "Signups/SignupView/utils/useSignupListHasRespondents";
import { useSignups } from "Signups/state.js";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";

import { FnrToggle, FnrToggleItems } from "UI/FnrToggle2";

import AddToGroup from "./Buttons/AddToGroup";
import CreateLinkedGroups from "./Buttons/CreateLinkedGroups";
import ExportButton from "./Buttons/Export";

export default function MoreOptionsContent({setShowPopover}) {
  const [
    {
      currentSignupList: { title },
    },
  ] = useSignups();
  const hasRespondents = useSignupListHasRespondents();
  const { isArchived } = useIsSignupClosed();
  const currentFilterRequest = window.fnReactBus.getCurrentFilterRequest();
  // currentFilterRequest can sometimes be `false`, an empty array, or an object (if actually filtering).
  const isCurrentlyFiltering =
    isObject(currentFilterRequest) && !isEmpty(currentFilterRequest);

  return (
    <Wrapper>
      {isCurrentlyFiltering ? (
        <FiltersNotice>
          Note: these actions will include all respondents, and are not based on
          currently filtered results.
        </FiltersNotice>
      ) : null}
      <FnrToggle style={{ maxWidth: 440, border: "none" }}>
        <FnrToggleItems>
          <ExportButton disabled={!hasRespondents} setShowPopover={setShowPopover} />
          <AddToGroup disabled={!hasRespondents} />
          {!hasRespondents && (
            <NoSignupsYet>
              <NoSignupsYetLine />
              <NoSignupsYetText>
                {`No one has signed up for ${title} yet.  Once people have signed up, you'll be able to perform the actions above.`}
              </NoSignupsYetText>
              <NoSignupsYetLine />
            </NoSignupsYet>
          )}
          <CreateLinkedGroups disabled={isArchived} />
        </FnrToggleItems>
      </FnrToggle>
    </Wrapper>
  );
}

MoreOptionsContent.propTypes = {
  setShowPopover: PropTypes.func.isRequired,
};

const Wrapper = styled.div``;

const NoSignupsYet = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
`;
const NoSignupsYetLine = styled.div`
  height: 1px;
  background: #828c8d;
  width: 60px;
  flex-grow: 0;
  flex-shrink: 0;
`;
const NoSignupsYetText = styled.div`
  padding: 0 8px;
  text-align: center;
  font-size: 12px;
  color: #828c8d;
  flex-grow: 1;
`;

const FiltersNotice = styled.div`
  color: var(--fnPurple);
  max-width: 440px;
  font-size: 14px;
  padding: 4px 4px 9px;
`;
